export default {
  "content": "<title>Filter</title><path d=\"M16 120h480v48H16zm80 112h320v48H96zm96 112h128v48H192z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};